import React, { useState, useEffect } from 'react';
import { Box, CircularProgress, Typography, Grid, IconButton } from '@mui/material';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import GetAppRoundedIcon from '@mui/icons-material/GetAppRounded'; // Import for download icon
import { fetchImageURL, deleteImage } from '../imageStorageHandling';
import { auth } from '../firebase';

function SavedPage() {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true); // Set initial loading state to true
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const user = auth.currentUser; // Get the user from auth
        const imageURLs = await fetchImageURL(user);
        setImages(imageURLs || []);
      } catch (error) {
        console.error('Error fetching images:', error);
        setError('Failed to fetch images. Please try again later.');
      }
      setLoading(false);
    };

    fetchImages();
  }, []);

  const handleImageDownload = (imageUrl) => {
    // Create a temporary anchor element
    const anchor = document.createElement('a');
    anchor.href = imageUrl;
    anchor.download = `downloaded_image_${new Date().getTime()}.jpg`; // Set the download filename
    anchor.target = '_blank'; // Open in a new tab
    anchor.click(); // Simulate a click event to trigger the download
  };

  const handleDelete = async (index, imageUrl) => {
    try {
      await deleteImage(imageUrl);
      setImages(current => current.filter((_, i) => i !== index));
    } catch (error) {
      console.error('Error deleting image:', error);
      setError('Failed to delete the image. Please try again later.');
    }
  };

  if (loading) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><CircularProgress /></Box>;
  }

  if (error) {
    return <Box sx={{ textAlign: 'center', marginTop: '20px' }}><Typography variant="h6" color="error">{error}</Typography></Box>;
  }

  return (
    <Box sx={{ width: '100%', flexGrow: 1 }}>
      <h1>Saved</h1>
      <Typography variant="subtitle1" sx={{ marginBottom: '20px' }}>Your saved designs will show up here.</Typography>
      <Grid container spacing={2}>
        {images.length ? images.map((imageUrl, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Box sx={{ position: 'relative', display: 'flex', borderRadius:'20px', justifyContent: 'center', alignItems: 'center', border: '1px solid #F5F5F5', transition: '0.3s', '&:hover': {boxShadow: '0px 3px 6px rgba(255, 76, 21, 1)'}, }}>
              <img src={imageUrl} alt={`Design ${index + 1}`} style={{ width: '100%', height: 'auto', borderRadius: '20px' }} />
              <IconButton onClick={() => handleDelete(index, imageUrl)} sx={{ position: 'absolute', top: '10px', right: '10px', color: 'black', backgroundColor: '#F5F5F5', '&:hover': { backgroundColor: '#E0E0E0' } }}>
                <DeleteRoundedIcon />
              </IconButton>
              <IconButton onClick={() => handleImageDownload(imageUrl)} sx={{ position: 'absolute', top: '10px', right: '60px', color: 'black', backgroundColor: '#F5F5F5', '&:hover': { backgroundColor: '#E0E0E0' } }}>
                <GetAppRoundedIcon />
              </IconButton>
            </Box>
          </Grid>
        )) : <Typography variant="h6" sx={{ margin: 'auto' }}>No designs found.</Typography>}
      </Grid>
    </Box>
  );
}

export default SavedPage;

